import React from "react";
import { Route } from "react-router-dom";
import LoginPage from "../pages/auth/LoginPage";
import CustomerRegisterPage from "../pages/auth/CustomerRegisterPage";
import AdminUserRegisterPage from "../pages/auth/AdminUserRegisterPage";
import PasswordSettingsPage from "../pages/auth/PasswordSettingsPage";

export default function AuthRoutes() {
  return (
      <>
        <Route path="/user-login" element={<LoginPage />} />
        <Route path="/user-register" element={<CustomerRegisterPage />} />
        <Route path="/admin-user-register" element={<AdminUserRegisterPage />} />
        <Route path="/password-setting" element={<PasswordSettingsPage />} />
      </>
    );
}




